import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/primary-arrow-left.png'


const _withScopeId = n => (_pushScopeId("data-v-2ba3bc5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "program-participation-detail"
}
const _hoisted_2 = { class: "back d-flex align-items-center" }
const _hoisted_3 = {
  key: 2,
  class: "pagination-box"
}

import { reactive, onMounted, onUnmounted, nextTick } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { request } from '@/utils';
  import { Collection } from '@/stores';
  import CampaignDetail from './components/campaign-detail.vue';
  import OnGoingProgramDetail from './components/on-going-program-detail.vue';
  import { ProgramDetail, defaultProgramDetail } from './components';
  import { useI18n } from 'vue-i18n';


  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const route = useRoute();
  const id = route.params.id;
  const detail = reactive<ProgramDetail>({ ...defaultProgramDetail });

  const store = reactive<Collection>(
    new Collection({
      params: {
        program_id_eq: '',
        is_offline_collection_eq: false,
        pdo_id_not_null: false,
        per_page: 20,
        page: route.query.page ? Number(route.query.page) : 1
      },
      fetch(params = {}) {
        return request.get('/program_shipments', { params });
      }
    })
  );

  const init = async () => {
    const { data } = await request.get<ProgramDetail>(`/user_requests/${id}`);
    Object.assign(detail, data);
    store.params.program_id_eq = data.target && data.target.id;
    await store.fetchData();
  };
  const destory = () => {
    Object.assign(detail, { ...defaultProgramDetail });
  };
  const reload = () => {
    store.fetchData();
  };

  const handlePageChange = (page: number) => {
    router.push({ query: { ...route.query, page: page } });
  };

  onMounted(init);
  onUnmounted(destory);

  const router = useRouter();
  async function handleBack() {
    router.back();
    await nextTick();
    if (router.currentRoute.value.name !== 'mine.collectionHistory') {
      router.replace({ name: 'mine.collectionHistory' });
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_unref(detail).id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "icon",
            onClick: handleBack
          }),
          _createElementVNode("span", {
            class: "text",
            onClick: handleBack
          }, _toDisplayString(_unref(t)('back')), 1)
        ]),
        (_unref(detail).target.type === 'Campaign')
          ? (_openBlock(), _createBlock(CampaignDetail, {
              key: 0,
              detail: _unref(detail),
              list: _unref(store).data,
              onReload: reload
            }, null, 8, ["detail", "list"]))
          : (_openBlock(), _createBlock(OnGoingProgramDetail, {
              key: 1,
              detail: _unref(detail),
              list: _unref(store).data,
              onReload: reload
            }, null, 8, ["detail", "list"])),
        (_unref(store).meta.total)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_AppPagination, {
                total: _unref(store).meta.total,
                "per-page": _unref(store).meta.per_page,
                page: _unref(store).meta.page,
                onChange: handlePageChange
              }, null, 8, ["total", "per-page", "page"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})